import React from 'react';

class ListErrors extends React.Component {
  render() {
    const errors = this.props.errors;
    if (errors) {
			if(errors.constructor === Array) {
	      return (
					<div className='mb-lg-15 alert alert-danger'>
	          {
	            Object.keys(errors).map(key => {
	              return (
	                <div className='alert-text font-weight-bold' key={key}>
	                  {errors[key]}
	                </div>
	              );
	            })
	          }
	        </div>
	      );
			} else {
				return (
					<div className='mb-lg-15 alert alert-danger'>
	          <div className='alert-text font-weight-bold'>
	            {errors}
	          </div>
	        </div>
	      );
			}
    } else {
      return null;
    }
  }
}

export default ListErrors;
